import { api } from "@/lib/api";

/**
 * Client-side helpers for the rewarded-ad flow. The web app uses Google AdSense
 * Ad Placement API (adBreak) with a mock fallback for no-fill. Mobile uses real
 * AdMob rewarded interstitials. The server contract is identical for both.
 */

export async function fetchAdsStatus() {
  const { data } = await api.get("/ads/status");
  return data;
}

/**
 * Report to the backend that a rewarded ad has finished playing so the
 * user's quota is refilled.
 * @param {"palm"|"chat"|"vastu"|"generic"} kind
 */
export async function grantAdReward(kind = "generic") {
  const endpoint = kind === "chat"
    ? "/ads/reward-chat"
    : kind === "vastu"
      ? "/ads/reward-vastu"
      : "/ads/reward";
  const { data } = await api.post(endpoint, { provider: "adsense" });
  return data;
}

/**
 * Detects the specific ad-required flavour from an axios error response.
 * Returns null if it's not an ad-required 402.
 */
export function detectAdRequired(err) {
  const status = err?.response?.status;
  const detail = err?.response?.data?.detail;
  if (status !== 402) return null;
  if (detail?.error === "ad_required") return "generic";
  if (detail?.error === "chat_ad_required" || detail?.error === "chat_quota_exceeded") return "chat";
  if (detail?.error === "vastu_ad_required") return "vastu";
  return null;
}
